import { Navigate } from 'react-router-dom'

export default function Index() {
  return <Navigate to="/settings/integrations/locations" replace />
}
